// The pinned note under the customer's name on the 360 (spec 09 §4.2's E2-2a1
// annotation, D-323 ruling 2). It comes from the 360's ONE GET
// (`pinned_note`), so it paints with the header and costs the < 2 s budget
// nothing. It is what the next person on the account must know before they
// call (D-229), which is why it sits above the tabs and not inside one.
//
// A redacted pinned note stays pinned and reads "Text removed by … on …". No
// pinned note, no block: the header reserves no space for one, because the
// one GET already decided whether it exists before the header painted.

import { useTranslation } from "react-i18next";
import type { CustomerNote } from "../../hooks/crm-queries";
import { NoteBody, NoteMeta } from "./note-meta";

export function PinnedNote({ note }: { note: CustomerNote | null }) {
  const { t } = useTranslation();
  if (note === null) return null;
  return (
    <section
      className="sales-pinned-note"
      data-testid="sales-360-pinned-note"
      data-origin={note.origin}
      aria-label={t("sales.notes.pinnedLabel")}
    >
      <span className="sales-pinned-label">{t("sales.notes.pinnedLabel")}</span>
      <NoteBody note={note} />
      <NoteMeta note={note} />
    </section>
  );
}
